import { render, staticRenderFns } from "./ProductDocumentationList.vue?vue&type=template&id=d86fc586&scoped=true"
import script from "./ProductDocumentationList.vue?vue&type=script&lang=js"
export * from "./ProductDocumentationList.vue?vue&type=script&lang=js"
import style0 from "./ProductDocumentationList.vue?vue&type=style&index=0&id=d86fc586&prod&scoped=true&lang=css"
import style1 from "./ProductDocumentationList.vue?vue&type=style&index=1&id=d86fc586&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86fc586",
  null
  
)

export default component.exports